
export default {
  name: "app-selecionar-inscricao-estadual-modal",
  props: {
    modalId: {
      type: String,
      required: true,
    },
    iePrincipal: {
      type: String,
      default: "",
    },
    enderecoPrincipal: {
      type: Object,
      default: null,
    },
    inscricoesAdicionais: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      inscricaoSelecionada: null,
    };
  },
  computed: {
    opcoesInscricoes() {
      const opcoes = [];

      if (this.iePrincipal && String(this.iePrincipal).trim() !== "") {
        opcoes.push({
          value: {
            numero_ie: this.iePrincipal,
            principal: true,
            endereco: this.enderecoPrincipal,
          },
          numero_ie: this.iePrincipal,
          principal: true,
          endereco: this.enderecoPrincipal,
        });
      }

      (this.inscricoesAdicionais || []).forEach((inscricao) => {
        const numeroIE =
          typeof inscricao === "string" ? inscricao : inscricao.numero_ie;
        const principal =
          typeof inscricao === "object" ? !!inscricao.principal : false;
        const endereco =
          typeof inscricao === "object" ? inscricao.endereco : null;

        if (!numeroIE) return;

        const jaExiste = opcoes.some((opcao) => opcao.numero_ie === numeroIE);

        if (!jaExiste) {
          opcoes.push({
            value: {
              numero_ie: numeroIE,
              principal: principal && opcoes.length === 0,
              endereco: endereco,
            },
            numero_ie: numeroIE,
            principal: principal && opcoes.length === 0,
            endereco: endereco,
          });
        }
      });

      return opcoes;
    },
  },
  methods: {
    resetSelecao() {
      this.inscricaoSelecionada = null;
    },
    confirmarSelecao() {
      if (!this.inscricaoSelecionada) {
        this.$toast.warning("Selecione uma inscrição estadual!");
        return;
      }

      this.$emit("selected", this.inscricaoSelecionada);
      this.$bvModal.hide(this.modalId);
    },
    abrir() {
      this.resetSelecao();
      this.$bvModal.show(this.modalId);
    },
  },
};
